// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_modalDialog__1ueLA {
  width: 328px;
}
@media (max-width: 576px) {
  .style_modalDialog__1ueLA {
    width: auto;
  }
}
.style_modalDialog__1ueLA .style_modalHeader__mo6J5 {
  justify-content: space-between;
  border: none;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_inputBox__Njsyo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_inputBox__Njsyo .style_label__m5j5T {
  font-size: 14px;
  line-height: 18px;
  color: #4a596a;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_balanceCreditChoice__63daH {
  display: inline-flex;
  flex-direction: column;
  gap: 14px;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_balanceCreditChoice__63daH input:checked {
  background-color: #5f8fdf;
  border-color: #5f8fdf;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_balanceCreditChoice__63daH input {
  height: 18px;
  width: 18px;
  margin-top: 2px;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_balanceCreditLbl__fhTMK {
  display: flex;
  caret-color: transparent;
  align-items: center;
  cursor: pointer;
  color: #4a596a;
  font-size: 16px;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_balanceCreditCtrl__bPXl1 {
  display: flex;
  gap: 12px;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_weekBalanceReset__Ns1lN {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_weekBalanceReset__Ns1lN span:first-child {
  font-size: 14px;
  line-height: 18px;
  color: #4a596a;
}
.style_modalDialog__1ueLA .style_modalBody__nWxxG .style_weekBalanceReset__Ns1lN span:last-child {
  display: flex;
  align-items: center;
  gap: 16px;
}
.style_modalDialog__1ueLA .style_modalFooter__Dyj8a {
  border: none;
}
.style_modalDialog__1ueLA .style_modalFooter__Dyj8a .style_dlgBtns__\\+pjxL {
  width: 100%;
  display: flex;
  gap: 16px;
}
.style_modalDialog__1ueLA .style_modalFooter__Dyj8a .style_dlgBtns__\\+pjxL button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Dialog/PlayerInfo/ChangeBalanceDlg/style.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;AADF;AAGE;EAHF;IAII,WAAA;EAAF;AACF;AAEE;EACE,8BAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAGI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADN;AAGM;EACE,eAAA;EACA,iBAAA;EACA,cCfS;ADcjB;AAKI;EACE,oBAAA;EACA,sBAAA;EACA,SAAA;AAHN;AAKM;EACE,yBC9BO;ED+BP,qBC/BO;AD4Bf;AAMM;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAJR;AAQI;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,cCzCW;ED0CX,eAAA;AANN;AASI;EACE,aAAA;EACA,SAAA;AAPN;AAUI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AARN;AAUM;EACE,eAAA;EACA,iBAAA;EACA,cC1DS;ADkDjB;AAWM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AATR;AAcE;EACE,YAAA;AAZJ;AAcI;EACE,WAAA;EACA,aAAA;EACA,SAAA;AAZN;AAcM;EACE,WAAA;AAZR","sourcesContent":["@import '../../../../variables.scss';\n\n.modalDialog {\n  width: 328px;\n\n  @media (max-width: 576px) {\n    width: auto;\n  }\n\n  .modalHeader {\n    justify-content: space-between;\n    border: none;\n  }\n\n  .modalBody {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    .inputBox {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      .label {\n        font-size: 14px;\n        line-height: 18px;\n        color: $text-color-800;\n      }\n    }\n\n    .balanceCreditChoice {\n      display: inline-flex;\n      flex-direction: column;\n      gap: 14px;\n\n      input:checked {\n        background-color: $active-color;\n        border-color: $active-color;\n      }\n\n      input {\n        height: 18px;\n        width: 18px;\n        margin-top: 2px;\n      }\n    }\n\n    .balanceCreditLbl {\n      display: flex;\n      caret-color: transparent;\n      align-items: center;\n      cursor: pointer;\n      color: $text-color-800;\n      font-size: 16px;\n    }\n\n    .balanceCreditCtrl {\n      display: flex;\n      gap: 12px;\n    }\n\n    .weekBalanceReset {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      span:first-child {\n        font-size: 14px;\n        line-height: 18px;\n        color: $text-color-800;\n      }\n\n      span:last-child {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n      }\n    }\n  }\n\n  .modalFooter {\n    border: none;\n\n    .dlgBtns {\n      width: 100%;\n      display: flex;\n      gap: 16px;\n\n      button {\n        width: 100%;\n      }\n    }\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalDialog": `style_modalDialog__1ueLA`,
	"modalHeader": `style_modalHeader__mo6J5`,
	"modalBody": `style_modalBody__nWxxG`,
	"inputBox": `style_inputBox__Njsyo`,
	"label": `style_label__m5j5T`,
	"balanceCreditChoice": `style_balanceCreditChoice__63daH`,
	"balanceCreditLbl": `style_balanceCreditLbl__fhTMK`,
	"balanceCreditCtrl": `style_balanceCreditCtrl__bPXl1`,
	"weekBalanceReset": `style_weekBalanceReset__Ns1lN`,
	"modalFooter": `style_modalFooter__Dyj8a`,
	"dlgBtns": `style_dlgBtns__+pjxL`
};
export default ___CSS_LOADER_EXPORT___;
